import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaTruck, FaMapMarkedAlt, FaCalendarAlt, FaUsers, FaFileContract, FaWarehouse, FaChartLine, FaShoppingCart, FaMedal, FaTv, FaGift, FaCamera, FaAward } from 'react-icons/fa';

const FeatureCard = ({ icon, title, description }) => (
  <div className="col-lg-3 col-md-4 col-sm-6">
    <div className="feature-card-modern glass-container">
      <div className="feature-icon-container">
        {icon}
        <div className="icon-glow"></div>
      </div>
      <h4 className="feature-title text-white">{title}</h4>
      <p className="feature-desc text-white-50">{description}</p>
    </div>
  </div>
);

const Features = () => {
  const { t } = useTranslation();

  const useScrollAnimation = () => {
    const ref = React.useRef();
    React.useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => entries.forEach(e => e.isIntersecting && e.target.classList.add('animate-in')),
        { threshold: 0.1 }
      );
      if (ref.current) observer.observe(ref.current);
      return () => observer.disconnect();
    }, []);
    return ref;
  };

  const ref = useScrollAnimation();

  return (
    <section className="features-modern py-5" ref={ref}>
      <div className="container">
        <div className="section-header text-center mb-5 fade-in-up">
          <div className="section-badge">
            <FaAward className="me-2" />
            <span className="text-primary">{t('features.title_part2')}</span>
          </div>
          <h2 className="section-title text-glow text-white">
            <span className="text-primary">{t('features.title_part1')}</span> {t('features.title_part2')}
          </h2>
          <p className="text-white-50 mt-3 mb-0" style={{ maxWidth: '600px', margin: '0 auto' }}>
            {t('features.subtitle')}
          </p>
          <div className="section-decoration"></div>
        </div>

        <div className="row g-4 fade-in-up stagger-2">
          <FeatureCard icon={<FaTruck className="feature-icon text-primary" />} title={t('features.jobs_title')} description={t('features.jobs_desc')} />
          <FeatureCard icon={<FaMapMarkedAlt className="feature-icon text-primary" />} title={t('features.map_title')} description={t('features.map_desc')} />
          <FeatureCard icon={<FaCalendarAlt className="feature-icon text-primary" />} title={t('features.convoys_title')} description={t('features.convoys_desc')} />
          <FeatureCard icon={<FaUsers className="feature-icon text-primary" />} title={t('features.divisions_title')} description={t('features.divisions_desc')} />
          <FeatureCard icon={<FaFileContract className="feature-icon text-primary" />} title={t('features.contracts_title')} description={t('features.contracts_desc')} />
          <FeatureCard icon={<FaWarehouse className="feature-icon text-primary" />} title={t('features.garage_title')} description={t('features.garage_desc')} />
          <FeatureCard icon={<FaChartLine className="feature-icon text-primary" />} title={t('features.leaderboards_title')} description={t('features.leaderboards_desc')} />
          <FeatureCard icon={<FaShoppingCart className="feature-icon text-primary" />} title={t('features.shop_title')} description={t('features.shop_desc')} />
          <FeatureCard icon={<FaMedal className="feature-icon text-primary" />} title={t('features.achievements_title')} description={t('features.achievements_desc')} />
          <FeatureCard icon={<FaTv className="feature-icon text-primary" />} title={t('features.streams_title')} description={t('features.streams_desc')} />
          <FeatureCard icon={<FaGift className="feature-icon text-primary" />} title={t('features.giveaways_title')} description={t('features.giveaways_desc')} />
          <FeatureCard icon={<FaCamera className="feature-icon text-primary" />} title={t('features.gallery_title')} description={t('features.gallery_desc')} />
        </div>

        <div className="text-center mt-5 fade-in-up stagger-3">
          <a href="https://hub.mileageriot.com/apply" target="_blank" rel="noopener noreferrer" className="btn btn-hero-primary">
            <span>{t('features.explore_hub') || t('header.buttons.join')}</span>
            <div className="btn-shine"></div>
          </a>
        </div>
      </div>
      <div className="section-bg-decoration"></div>
    </section>
  );
};

export default Features;
